// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl:'https://whatnow-staging.herokuapp.com/api',
  // apiUrl:'http://localhost:3000/api',
  // apiUrl:'https://486e2df0a869.ngrok.io/api',
  // apiUrl:'https://whatnowsms.herokuapp.com/api',
  stripePublishableKey: 'pk_test_51Q7Zq0P6185OJSR6P34DWeFTpaCIKJ4oVXVAaXg1LiC1KAjWKNksgY6qYjuYWvVevQUm375XbSnA3LA0MonLragt00WKb8kfPp'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
